import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError, money } from "@/lib/api";

export default function TradeDialog({ open, onOpenChange, mode, assetType, assetId, label, price, maxQty, cash, onDone }) {
  const [qty, setQty] = useState(1);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setQty(1); }, [open]);

  const total = (Number(qty) || 0) * price;
  const isBuy = mode === "buy";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/trade/${mode}`, { asset_type: assetType, asset_id: assetId, quantity: Number(qty) });
      toast.success(`${isBuy ? "Bought" : "Sold"} ${qty} ${assetType === "stock" ? "shares of" : "shares in"} ${label}`);
      onOpenChange(false);
      onDone?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-line bg-panel sm:max-w-md" data-testid="trade-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{isBuy ? "Buy" : "Sell"} {label}</DialogTitle>
          <DialogDescription>Price per share: <span className="font-mono text-white">{money(price)}</span></DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="trade-qty">Number of shares</Label>
            <Input id="trade-qty" type="number" inputMode="numeric" min={1} max={maxQty || undefined} step={1} required value={qty}
              onChange={(e) => setQty(e.target.value)} className="field font-mono" data-testid="trade-quantity-input" />
            {maxQty != null && <p className="text-xs text-slate-500">{isBuy ? "Available" : "You hold"}: <span className="font-mono">{maxQty}</span></p>}
          </div>
          <div className="space-y-2 rounded-xl border border-line bg-obsidian/60 p-4 text-sm">
            <div className="flex justify-between"><span className="text-slate-400">{isBuy ? "Total cost" : "Proceeds"}</span><span className="font-mono text-white" data-testid="trade-total">{money(total)}</span></div>
            {cash != null && <div className="flex justify-between"><span className="text-slate-400">Cash balance</span><span className="font-mono text-slate-300">{money(cash)}</span></div>}
          </div>
          <button type="submit" disabled={busy || !qty || qty < 1} className={`${isBuy ? "btn-primary" : "btn-gold"} w-full`} data-testid={isBuy ? "stock-buy-confirm-button" : "trade-sell-confirm-button"}>
            {busy ? "Processing..." : `Confirm ${isBuy ? "purchase" : "sale"}`}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
